import * as React from "react";
import { UitkIcon, UitkIconSize } from "../uitk-react-icons/index.js";
import { UitkLayoutFlexItem } from "../uitk-react-layout-flex/index.js";
import { analyticsTracker, classNames } from "../uitk-react-utils/index.js";
import { ToolbarHeaderType } from "./index.js";
export class UitkToolbarAction extends React.Component {
  render() {
    const {
      action,
      actionContent,
      analytics,
      buttonRef,
      iconLabel,
      id,
      type,
      toolbarType
    } = this.props;
    const iconHasShadow = toolbarType === ToolbarHeaderType.OVERLAY;
    return /* @__PURE__ */ React.createElement(UitkLayoutFlexItem, { className: classNames("uitk-toolbar-button"), shrink: 0 }, /* @__PURE__ */ React.createElement(
      "button",
      {
        type: "button",
        onClick: action,
        onClickCapture: analyticsTracker.bind(this, analytics),
        "data-icon": `tool-${type}`,
        ref: buttonRef,
        id: `${id}-${type}`
      },
      /* @__PURE__ */ React.createElement(
        UitkIcon,
        {
          id: `${id}-${type}-toolbar`,
          name: type,
          size: UitkIconSize.MEDIUM,
          title: iconLabel,
          shadow: iconHasShadow
        }
      ),
      actionContent && /* @__PURE__ */ React.createElement("span", { className: classNames("uitk-toolbar-action-content") }, actionContent)
    ));
  }
}
